import React from 'react'
import "./BlogPost.css";

import easter from "../../Assets/b73/easter.jpg"

function Blog73() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Have a blessed Easter Sunday</h1>
                    <h6>April 05, 2026 at 08:55 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={easter} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                </div>
            </div>
        </div>
    )
}

export default Blog73;
